import axiosClient from "./axiosClient";
import * as Config from "../constants/Config";
let { appname } = window.app;

const tmdbApi = {
  websitedefaults: (params) => {
    const url = "/config?" + 'appname=' + appname;
    return axiosClient.get(url, params);
  },

  appMenus: (params) => {
    const url = "/menus?" + 'appname=' + appname + '&appType=client&page=landingpage';
    return axiosClient.get(url, params);
  },

  signin: (params) => {
    const url = "/signIn?appname=" + appname;
    return axiosClient.post(url, params);
  },


  CreatePassword: (params) => {
    const url = "/setPassword?appname=" + appname;
    return axiosClient.post(url, params);
  },

  ForgotPassword: (params) => {
    const url = "/forgotPassword?appname=" + appname;
    return axiosClient.post(url, params);
  },
  
  Adduser: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/user?appname=" + appname + "&token=" + token+ '&userid=' + userid;
    return axiosClient.put(url, params);
  },

  AddQuiz: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/addQuiz?appname=" + appname + "&userid=" + userid
    return axiosClient.post(url, params);
  },

  UpdateQuiz: (params, quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateQuiz?appname=" + appname + "&userid=" + userid + "&quizid=" + quizid
    return axiosClient.post(url, params);
  },

  AddAnswer: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/addAnswer?appname=" + appname + "&userid=" + userid
    return axiosClient.post(url, params);
  },

  UpdateAnswer: (params, answerid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateAnswer?appname=" + appname + "&userid=" + userid+"&answerid="+answerid
    return axiosClient.post(url, params);
  },

  AddQuestion: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/addQuestion?appname=" + appname  + "&userid=" + userid
    return axiosClient.post(url, params);
  },

  UpdateQuestion: (params, questionid, quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateQuestion?appname=" + appname  + "&userid=" + userid + "&questionid="+questionid + "&quizid=" + quizid
    return axiosClient.post(url, params);
  },
  
  quizParticipation: (params, liveParticipants, clientid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizParticipants?appname=" + appname +"&liveparticipation="+liveParticipants +"&clientid="+clientid 
    return axiosClient.post(url, params);
  },

  announceResult: (quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/anounceResult?appname=" + appname + "&userid=" + userid + "&quizid=" + quizid
    return axiosClient.post(url);
  },

  duplicateQuiz: (quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/duplicateQuiz?appname=" + appname + "&userid=" + userid + "&quizid=" + quizid
    return axiosClient.post(url);
  },

  viewResult: (participantId) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/viewResult?appname=" + appname + "&userid=" + userid + "&participationid=" + participantId
    return axiosClient.post(url);
  },
  signUp: (params) => {
    const url = "/userSignUp?appname=" + appname;
    return axiosClient.post(url, params);
  },
  Login: (params) => {
    const url = "/userSignIn?appname=" + appname;
    return axiosClient.post(url, params);
  },
  Logout: (params) => {
    const url = "/clientSignout?appname=" + appname;
    return axiosClient.post(url, params);
  },
  winnerSubmit: (params, quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/winnerUpdate?appname=" + appname + "&quizid=" + quizid 
    return axiosClient.post(url, params);
  },

  answerInfo: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/answerInfo?appname=" + appname + "&userid=" + userid 
    return axiosClient.post(url, {});
  },

  answerSearchInfo: (search) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/answerInfo?appname=" + appname + "&userid=" + userid + "&search="+search
    return axiosClient.post(url, {});
  },

  deleteAnswer: (answerid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateAnswer?appname=" + appname + "&userid=" + userid + "&answerid=" + answerid + "&type=delete"
    return axiosClient.post(url, {});
  },

  quizInfo: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&userid=" + userid 
    return axiosClient.post(url, {});
  },

  quizInfoId: (quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&quizid=" + quizid 
    return axiosClient.post(url, {});
  },

  ViewResults: () => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/viewResult?appname=" + appname + "&clientid=" + clientid 
    return axiosClient.post(url, {});
  },

  viewResult1: (date) => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/viewResult?appname=" + appname + "&clientid=" + clientid +"&date="+date
    return axiosClient.post(url, {});
  },

  reportsInfo: (quizId) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/reports?appname=" + appname + "&userid=" + userid + "&quizid="+quizId
    return axiosClient.post(url, {});
  },
  SingleReports: (id) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/reports?appname=" + appname + "&quizid="+id
    return axiosClient.post(url, {});
  },
  winnersInfo: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/winner?appname=" + appname + "&userid=" + userid 
    return axiosClient.post(url, {});
  },
  configData: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/configData?appname=" + appname
    return axiosClient.get(url, {});
  },

  quizHomeInfo: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&userid=" + userid + "&type=client"+"&status=all"
    return axiosClient.post(url, {});
  },

  quizInfoCompeleted: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&userid=" + userid + "&type=client&status=COMPLETED"
    return axiosClient.post(url, {});
  },

  quizHomeFilterInfo: (status) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&userid=" + userid + "&type=client&status=" + status
    return axiosClient.post(url, {});
  },

  quizSearchInfo: (search) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&userid=" + userid + "&search="+search
    return axiosClient.post(url, {});
  },
  quizReportsSearchInfo: (search) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&userid=" + userid + "&type=client&status=COMPLETED&search="+search
    return axiosClient.post(url, {});
  },

  deleteQuiz: (quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateQuiz?appname=" + appname + "&userid=" + userid + "&quizid=" + quizid + "&type=delete"
    return axiosClient.post(url, {});
  },
  deleteQuizFile: (quizid,params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/deleteQuizFile?appname=" + appname +  "&quizid=" + quizid 
    return axiosClient.post(url, params);
  },
  deleteQuestion: (quizid, params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateQuestion?appname=" + appname + "&userid=" + userid + "&quizid=" + quizid + "&type=delete"
    return axiosClient.post(url, params);
  },

  deleteQuestionslist: (quizid, params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateQuestion?appname=" + appname + "&userid=" + userid + "&quizid=" + quizid + "&type=delete"
    return axiosClient.post(url, params);
  },

  deleteImage: (questionid, params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/deleteFiles?appname=" + appname + "&questionid=" + questionid
    return axiosClient.post(url, params);
  },

  questionInfo: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/questionInfo?appname=" + appname + "&quizid="+params.quizid
    return axiosClient.post(url, {});
  },

  getContent: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/content?appname=" + appname + "&token=" + token+ '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  dataImport: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")

    const url = "/importData?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  getCompany: (params) => {
    const token = localStorage.getItem("token")
    const url = "/companies?appname=" + appname + "&token=" + token;
    return axiosClient.get(url, params);
  },

  SaveClient: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/client?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, params);
  },
  SaveClientData: (params) => {
    const payload=params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
   const url = "/client?appname=" + appname + "&token=" + token + '&userid=' + userid+'&leadid='+params.leadid;
    if (payload.hasOwnProperty('leadid')) delete payload['leadid']
    return axiosClient.put(url, payload);
  },
  FollowUp: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/followup?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, params);
  },

  AddCompany: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/company?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, params); 
  },

  getAccount: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/accountmangers?appname=" + appname + "&token=" + token +'&userid='+ userid;
    return axiosClient.get(url, params);
  },

  getCategory: (params) => {
    const token = localStorage.getItem("token")
    // const url = "/category?appname=" + appname + "&token=" + token +"&status=ACTIVE";
    const url = "/category?appname=" + appname + "&token=" + token;
    return axiosClient.get(url, params);
  },

  getLookUp: (params) => {
    const token = localStorage.getItem("token")
    
    let payload = params
    let projection = params?.projection ? params?.projection : "";
    let status = params?.status ? params?.status : "";
    let url = "/lookups?appname=" + appname + "&token=" + token;
    
    if( projection != "") { url = url + `&projection=tiny`}
    if( status != "") { url = url + `&status=ACTIVE`}
   
    if (payload.hasOwnProperty('projection')) delete payload['projection']
    if (payload.hasOwnProperty('status')) delete payload['status']

    return axiosClient.post(url, payload);

  },

  getUserData: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/userInfo?appname="+ appname +"&userId="+userid;
    return axiosClient.post(url);
  },

  getClientData: () => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/clientInfo?appname="+ appname +"&clientid="+clientid;
    return axiosClient.post(url);
  },

  filterCategory: (params) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")
 //   let pageNumber = params.pageNumber || 1;
//    let assetcount = params.assetcount || 10;
   // let cat = params.category || "";
    let url = "/content?appname="+ appname + "&token=" + token + '&userid=' + userid;
    // if( pageNumber != "") { url = url + `&pageNumber=${pageNumber}`}
    // if( assetcount != "") {url = url + `&assetcount=${assetcount}`}
    return axiosClient.post(url, params);

  },

  userDataUpdate: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateUser?appname="+ appname +"&userid="+userid
    return axiosClient.post(url, params);
  },
clientDataUpdate: (params) => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/updateClient?appname="+ appname +"&clientid="+clientid
    return axiosClient.post(url, params);
  },

   pwdGenerate: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updatePassword?appname=" + appname+ '&userid=' + userid;
    return axiosClient.post(url, params);
  },
  clientPwdGenerate: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateClientPassword?appname=" + appname;
    return axiosClient.post(url, params);
  },
  clientForgotPwdGenerate: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/forgotClientPassword?appname=" + appname;
    return axiosClient.post(url, params);
  },
  clientSearch: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/clientSearch?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  AllDeals: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/clientEnquiry?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  UpdateDeals: (params) => {
    let payload=params;
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/clientEnquiry?appname=" + appname + "&enquiryid=" + params.enquiryid +  "&token=" + token+ '&userid=' + userid;
    if (payload.hasOwnProperty('enquiryid')) delete payload['enquiryid']
    return axiosClient.put(url, payload);
  },

  UpdateFollowupDeals: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/enquiryFollowup?appname=" + appname + "&token=" + token+ '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  AddDeal: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    
    const url = "/clientEnquiry?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },
  AddLead: (params) => {

    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const payload={...params}
    const url = "/addLead?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, payload);
  },
  NotifyAdmin: (params) => {
    let payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/notifyAdmin?appname=" + appname + "&token=" + token + '&userid=' + userid+'&leadid='+params.leadid;
    if (payload.hasOwnProperty('leadid')) delete payload['leadid']
    return axiosClient.post(url, params);
  },
  AddConversation: (params)=>{
    let payload = params
  const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/addConversation?appname=" + appname + "&token=" + token + '&userid=' + userid +'&leadid='+params.leadid;
    if (payload.hasOwnProperty('leadid')) delete payload['leadid']
    return axiosClient.put(url, payload);
  },
  GetConversations: (params) => {
    let payload= params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/conversations?appname=" + appname + "&token=" + token +'&userid=' + userid+'&leadid='+params.leadid;
    return axiosClient.get(url, payload);
  },
  UpdateConvData:(params)=>{
    const payload=params
    const token = localStorage.getItem("token")
    const url = "/updateConversation?appname=" + appname + "&token=" + token+"&conversationid="+params.conversationid+"&status="+params.status ;
    if (payload.hasOwnProperty('status')) delete payload['status']
    if (payload.hasOwnProperty('conversationid')) delete payload['conversationid']
    return axiosClient.post(url,payload);
  },
  UpdateLead:(params)=>{
    const payload=params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateLead?appname=" + appname + "&token=" + token +'&userid=' + userid+'&leadid='+params.leadid+'&clientid='+params.clientid;
    if(payload.hasOwnProperty('leadid')) delete payload['leadid']
    if (payload.hasOwnProperty('clientid')) delete payload['clientid']
    return axiosClient.post(url, payload);
  },
  GetConversationComments:(params)=>{
    let payload = params
    const token = localStorage.getItem("token")
      const userid = localStorage.getItem("userId")
      const url = "/addConversationComment?appname=" + appname + "&token=" + token + '&userid=' + userid +'&conversationid='+params.conversationid;
      if (payload.hasOwnProperty('conversationid')) delete payload['conversationid']
      return axiosClient.post(url, payload);
  },
  GetConversationsCommentData: (params) => {
    let payload= params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateconversationComment?appname=" + appname + "&token=" + token +'&userid=' + userid+'&commentid='+params.leadid;
    return axiosClient.get(url, payload);
  },
  GetLeads: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/leads?appname=" + appname + "&token=" + token+'&userid=' + userid ;
    return axiosClient.get(url, params);
  },
  
  GetSellers: (params) => {
    const token = localStorage.getItem("token")
    const url = "/companyList?appname=" + appname + "&token=" + token ;
    return axiosClient.get(url, params);
  },
  

  GetBuyers: (params) => {
    const token = localStorage.getItem("token")
    const url = "/blockCompanyList?appname=" + appname + "&token=" + token +"&companyid="+params.id;
    return axiosClient.get(url, params);
  },

  GetBlockBuyers: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/getblockCompanies?appname=" + appname + "&token=" + token + '&userid=' + userid ;
    return axiosClient.post(url, params);
  },

  SignOutUser: (params) => {
    let payload = {emailid:params.emailId}
    // const url = "/signout?appname="+appname+"&emailid="+params.emailId;
    const url = "/signout?appname="+appname;
    return axiosClient.post(url,payload);
  },

  mapImport: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
  
    const url = "/importDataV2?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },
  getBiddingLookUp: (params) => {
    const token = localStorage.getItem("token")
    let payload = params
    
    let status = params?.status ? params?.status : "";
    let url = "/biddingLookups?appname=" + appname + "&token=" + token;
    if( status != "") {url = url + `&status=ACTIVE`;}
    if (payload.hasOwnProperty('status')) delete payload['status']
    return axiosClient.post(url, payload);
  },

};



export default tmdbApi;
